import { buildNotesWithCurrencyRate } from "../../../../utils/pdf/page";
import { buildAutoNote } from "../../../../utils/pdf/buildAutoTable";
import { renderIrasChargeableIncomeTable } from "../iras/renderIrasChargeableIncomeTable";
import { renderIrasMainCompSections } from "../iras/renderIrasMainCompSections";
import { renderIrasUnabsorbedSummary } from "../iras/renderIrasUnabsorbedSummary";
import { createIrasPdfGenerator } from "../iras/layoutConfig";
import { getIrasNoteTableOptions } from "../iras/tableSpacing";
import { buildInvestCoMainCompSections } from "./buildInvestCoMainCompSections";

const generateInvestCoMainCompPdf = ({
  forView,
  company,
  currency,
  currencyRate,
  referenceData,
  unutilisedCapitalAllowances,
  unutilisedLosses,
  unutilisedDonations,
  corporateIncomeTaxRebate,
  currentYearRebate,
  isStartup,
  taxPreviouslyAssessed,
  computedSummary,
  unabsorbedSummary,
  comments,
  reviewNote,
  isExcel = false,
  pdfDensity = "default",
  pdfSpacingOptions,
  scheduleName = "Main Tax Computation",
}) => {
  const pdf = createIrasPdfGenerator(isExcel);
  const schedule = { name: scheduleName };
  const currencyView = currency ?? company.currency;
  const isCompact = pdfDensity === "compact";
  const tableSpacingOptions = {
    density: pdfDensity,
    overrides: pdfSpacingOptions,
  };

  const sections = buildInvestCoMainCompSections({
    referenceData,
  });
  const renderResult = renderIrasMainCompSections({
    company,
    currencyRate,
    currencyView,
    forView,
    isCompact,
    pdf,
    reviewNote,
    schedule,
    sections,
    tableSpacingOptions,
    unutilisedCapitalAllowances,
    unutilisedDonations,
    unutilisedLosses,
  });
  const chargeableIncomeResult = renderIrasChargeableIncomeTable({
    chargeableIncomeBeforeExemptAmount:
      renderResult.chargeableIncomeBeforeExemptAmount,
    company,
    computedSummary,
    corporateIncomeTaxRebate,
    currentYearRebate,
    currencyView,
    forView,
    isCompact,
    isStartup,
    pdf,
    reviewNote: renderResult.reviewNote,
    schedule,
    tableSpacingOptions,
    taxPreviouslyAssessed,
  });

  buildAutoNote(
    pdf,
    forView,
    company,
    schedule,
    buildNotesWithCurrencyRate(company, comments),
    chargeableIncomeResult.reviewNote,
    [],
    false,
    "Notes/Comments",
    getIrasNoteTableOptions(pdf, tableSpacingOptions),
  );

  renderIrasUnabsorbedSummary({
    company,
    currencyRate,
    currencyView,
    pdf,
    tableSpacingOptions,
    unabsorbedSummary,
  });

  return pdf.getDoc(forView, company, schedule);
};

export default generateInvestCoMainCompPdf;
